export const iconFontAwesomeArrowsUpDownLeftRight = (
	<i className="fa-solid fa-up-down-left-right"></i>
);
